<template>
  <div>
    <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>

    <div class="bg-light py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="card border-0 shadow rounded-lg" data-aos="fade-up">
              <div class="card-body p-4 p-md-5">
                <!-- Spanish Version -->
                <section lang="es" id="spanish-terms" aria-labelledby="spanish-title">
                  <div class="mb-4 pb-3 border-bottom">
                    <h1 id="spanish-title" class="text-primary font-weight-bold mb-1">Términos de Servicio</h1>
                    
                  </div>

                  <div class="terms-content">
                    <p>
                      Estos Términos de Servicio ("Términos") regulan el uso de la aplicación y servicios de Total Realty. Al usar nuestros servicios, usted acepta cumplir con estos Términos.
                    </p>

                    <ol class="terms-list">
                      <li>
                        <strong>Propósito:</strong> La aplicación permite a las agencias inmobiliarias administrar listados de propiedades y conectarse con plataformas de terceros como
                        Facebook e Instagram.
                      </li>
                      <li>
                        <strong>Responsabilidad del Usuario:</strong> Usted es responsable de la exactitud de la información que proporcione y de cumplir con las políticas de
                        Facebook/Instagram.
                      </li>
                      <li><strong>Uso de Datos:</strong> Solo utilizamos sus datos para brindar la funcionalidad solicitada, como publicar contenido en sus Páginas o cuentas.</li>
                      <li>
                        <strong>Responsabilidad:</strong> Total Realty no es responsable por interrupciones o restricciones impuestas por servicios de terceros (ej. plataformas de Meta).
                      </li>
                      <li><strong>Modificaciones:</strong> Podemos actualizar estos Términos ocasionalmente. El uso continuo del servicio significa que acepta los nuevos Términos.</li>
                    </ol>

                    <p class="contact-info mt-4">
                      Para consultas, contáctenos al correo <a href="mailto:info@totalnica.com" class="text-primary font-weight-bold">info@totalnica.com</a>
                    </p>
                  </div>
                </section>

                <!-- Divider -->
                <div class="divider my-5" aria-hidden="true"></div>

                <!-- English Version -->
                <section lang="en" id="english-terms" aria-labelledby="english-title">
                  <div class="mb-4 pb-3 border-bottom">
                    <h1 id="english-title" class="text-primary font-weight-bold mb-1">Terms of Service</h1>
                    
                  </div>

                  <div class="terms-content">
                    <p>These Terms of Service ("Terms") govern the use of the Total Realty application and services. By using our services, you agree to comply with these Terms.</p>

                    <ol class="terms-list">
                      <li>
                        <strong>Purpose:</strong> The application allows real estate agencies to manage property listings and connect with third-party platforms such as Facebook and Instagram.
                      </li>
                      <li><strong>User Responsibility:</strong> You are responsible for the accuracy of the information you provide and for complying with Facebook/Instagram policies.</li>
                      <li><strong>Data Use:</strong> We only use your data to provide the requested functionality, such as publishing content to your Pages or accounts.</li>
                      <li><strong>Liability:</strong> Total Realty is not liable for outages or restrictions imposed by third-party services (e.g., Meta platforms).</li>
                      <li><strong>Modifications:</strong> We may update these Terms from time to time. Continued use of the service means you accept the new Terms.</li>
                    </ol>

                    <p class="contact-info mt-4">
                      For questions, please contact us at <a href="mailto:info@totalnica.com" class="text-primary font-weight-bold">info@totalnica.com</a>
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["NavSolid"],
  name: "TermsOfService",
};
</script>

<style scoped>
.terms-content p {
  margin: 1.2rem 0;
  line-height: 1.7;
  color: var(--text);
}

.terms-list {
  margin: 1.5rem 0;
  padding-left: 1.5rem;
}

.terms-list li {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.terms-list strong {
  color: var(--primary);
}

.contact-info {
  padding: 1rem;
  background-color: var(--bg-light);
  border-radius: var(--radius);
}

.divider {
  border-top: 2px dashed var(--border);
}

section h1 {
  font-size: 1.75rem;
  color: var(--primary);
}

a:hover {
  text-decoration: underline;
}
</style>
